// ActivitySurface.jsx — the SINGLE renderer of the Activity destination (m3-06a).
//
// This is the one place that maps an activity view-model descriptor → JSX. Both placements
// (Standard full-page AND the Agent right panel) render <ActivitySurface> from the SAME
// `buildActivityViewModel()` output, so the two can never drift — the continuity contract.
//
// m3-06a ships the board tab (real ProjectBoardPage) + a Triggered-Tasks placeholder that
// m3-16a replaces. The segmented control (sticky/blur on page, plain in panel) is m3-11's
// detail; m3-06a renders a minimal host-controlled tab switch so the shell is coherent.

import React from "react"
import ProjectBoardPage from "../pages/ProjectBoardPage.jsx"
import TriggeredTasksList from "./TriggeredTasksList.jsx"

// Render the descriptor produced by buildActivityViewModel. The `vm` argument is the SINGLE
// source — callers must pass the view-model, not raw props, so the contract holds.
export default function ActivitySurface({ vm }) {
  if (!vm) return null
  const { surface, surfaceProps, surfaceKey, inPanel } = vm

  let body
  if (surface === "ProjectBoard") {
    body = (
      <ProjectBoardPage
        companySlug={surfaceProps.companySlug}
        litTask={surfaceProps.litTask}
        onAsk={surfaceProps.onAsk}
      />
    )
  } else {
    // Task 9: seedJob (from a consumed library launch) opens NewAgentForm prefilled in
    // library-trigger mode. Threaded through surfaceProps so the panel placement receives it.
    // Item #7: `inPanel` ⇔ agent mode (the panel placement exists ONLY in the agent layout, the
    // page placement only in Standard) — it drives the mode-preserving View-all href. Passed from
    // the vm's placement flag, NOT surfaceProps, which stays placement-invariant by contract.
    body = <TriggeredTasksList seedJob={surfaceProps.seedJob} agentMode={inPanel} />
  }

  return (
    <div
      key={surfaceKey}
      className={`ax-surface ${inPanel ? "ax-surface--panel" : "ax-surface--page"} pgx-in`}
    >
      {body}
    </div>
  )
}
